module.exports = "../assets/yachtfull-logo-blue-bg-no-brands.5ebed093.svg";